(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[163],{

/***/ 7018:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content",
      function () {
        return __webpack_require__(4645);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ ContentPage; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./components/layout/PageLayout.tsx + 4 modules
var PageLayout = __webpack_require__(2582);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.3_65aaefrptgalbi6a2fwpzxfmae/node_modules/next/image.js
var next_image = __webpack_require__(7659);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(959);
;// CONCATENATED MODULE: ./components/youtube/youtubePreview.tsx



var YoutubePreview = function(param) {
    var item = param.item;
    var ref = (0,react.useState)(false), showIframe = ref[0], setShowIframe = ref[1];
    var _snippet = item.snippet, title = _snippet.title, medium = _snippet.thumbnails.medium, videoId = _snippet.resourceId.videoId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-knut h-full rounded-lg bg-knut-light-bg-info transition duration-300 hover:bg-knut-light-bg dark:bg-knut-dark-bg-info hover:dark:bg-knut-dark-bg ",
        children: [
            showIframe ? /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                className: "aspect-video w-full",
                src: "https://www.youtube.com/embed/".concat(videoId, "?autoplay=1"),
                title: "YouTube video player",
                frameBorder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowFullScreen: true
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                onClick: function() {
                    return setShowIframe(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: medium.url,
                    height: 315,
                    width: 560,
                    alt: title,
                    className: "aspect-video w-full"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-l p-4 text-knut-light-header dark:text-knut-dark-header",
                children: title
            })
        ]
    });
};
/* harmony default export */ var youtubePreview = (YoutubePreview);

// EXTERNAL MODULE: ./content/links.ts
var links = __webpack_require__(2304);
// EXTERNAL MODULE: ./content/text.ts
var content_text = __webpack_require__(9862);
;// CONCATENATED MODULE: ./pages/content/index.tsx





var __N_SSG = true;
function ContentPage(param) {
    var playlist = param.playlist;
    var og = {
        site_name: content_text/* seo.title */.$K.title,
        title: "Content - " + content_text/* seo.title */.$K.title,
        description: "Collection of content from Youtube",
        type: "video.other",
        url: links/* baseUrl */.FH + "/content"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout/* default */.Z, {
        widthClassName: "container flex-1 mx-auto p-4 max-w-none",
        openGraph: og,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto w-11/12",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "text-3xl pb-5 font-bold",
                    children: "Content"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid auto-rows-max gap-4",
                    style: {
                        gridTemplateColumns: "repeat(auto-fill,minmax(260px,1fr))"
                    },
                    children: playlist.reverse().map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(youtubePreview, {
                            item: item
                        }, item.id);
                    })
                })
            ]
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [154,555,131,774,888,179], function() { return __webpack_exec__(7018); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);